import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
import { pets } from '../../data/animaux';
interface LostPetPickerProps {
  value: string | null;
  onChange: (petId: string) => void;
  invalid?: boolean;
}

/** Choix de l'animal perdu parmi les animaux enregistrés au dossier. */
export function LostPetPicker({
  value,
  onChange,
  invalid
}: LostPetPickerProps) {
  return <motion.fieldset initial={{
    opacity: 0,
    y: 6
  }} animate={{
    opacity: 1,
    y: 0
  }} transition={{
    duration: 0.22,
    ease: [0.23, 1, 0.32, 1]
  }} className="mt-5" data-id="element-1229" data-mp="3cjpkb88jdel5">
      <legend className="text-[13px] font-bold text-ville-navy" data-id="element-1230" data-mp="3mglvjlptkete">
        Quel animal avez-vous perdu ?<span className="text-ville-coral" data-id="element-1231" data-mp="3r7kg4xhubz2g"> *</span>
      </legend>
      <div role="radiogroup" className="mt-2 grid gap-3 sm:grid-cols-2" data-id="element-1232" data-mp="3r9x5vwtubdq2">
        {pets.map(pet => {
        const selected = value === pet.id;
        return <button key={pet.id} type="button" role="radio" aria-checked={selected} onClick={() => onChange(pet.id)} className={`flex items-center gap-3 rounded-2xl border p-3 text-left transition-colors duration-150 ease-ville focus:outline-none focus-visible:ring-2 focus-visible:ring-ville-indigo ${selected ? 'border-ville-navy bg-ville-indigo-soft' : invalid ? 'border-red-500 hover:border-red-600' : 'border-slate-200 hover:border-ville-navy'}`} data-id="element-1233" data-mp="2yq8a4e1qpe7s">
              <img src={pet.photo} alt="" className="h-14 w-14 shrink-0 rounded-xl object-cover" data-id="element-1234" data-mp="79ebqrv3y8vk" />
              <span className="min-w-0 flex-1" data-id="element-1235" data-mp="38cdad90m0un">
                <span className="block font-bold text-ville-navy" data-id="element-1236" data-mp="39ngobyjt6l8">{pet.name}</span>
                <span className="block text-sm text-slate-600" data-id="element-1237" data-mp="21mdzx9dk0beg">
                  {pet.species} · {pet.breed}
                </span>
                <span className="block text-xs text-slate-500" data-id="element-1238" data-mp="1xjzfiku8l3l2">Médaille {pet.medal}</span>
              </span>
              <span aria-hidden="true" className={`grid h-6 w-6 shrink-0 place-items-center rounded-full border ${selected ? 'border-ville-navy bg-ville-navy text-white' : 'border-slate-300'}`} data-id="element-1239" data-mp="3r2zq74xylxuo">
                {selected && <CheckIcon className="h-3.5 w-3.5" data-id="element-1240" data-mp="3m3n3ck738qs3" />}
              </span>
            </button>;
      })}
      </div>
    </motion.fieldset>;
}